import React from 'react';
import Scatter from '@splunk/dashboard-visualizations/Scatter';

export default () => (
    <Scatter
        options={{}}
        encoding={{
            category: 'primary.category',
            x: 'primary.date_hour',
            y: 'primary.count',
        }}
        dataSources={{
            primary: {
                requestParams: { offset: 0, count: 20 },
                data: {
                    fields: [
                        {
                            name: 'date_hour',
                        },
                        {
                            name: 'count',
                        },
                        {
                            name: 'category',
                        },
                    ],
                    columns: [
                        [
                            '13',
                            '14',
                            '15',
                            '16',
                            '17',
                            '18',
                            '19',
                            '10',
                            '20',
                            '21',
                            '22',
                            '23',
                            '3',
                            '4',
                            '5',
                        ],
                        [
                            '1109',
                            '1108',
                            '1098',
                            '1088',
                            '1097',
                            '1086',
                            '1107',
                            '1090',
                            '1150',
                            '2100',
                            '1070',
                            '1097',
                            '1096',
                            '1107',
                            '1152',
                        ],
                        [
                            'Gen Electric GE36',
                            'General Electric TF39 high bypass turbofan',
                            'Pratt & Whitney R-4360 Wasp Major',
                            'Allison V-1710',
                            'Sanford Alexander Moss',
                            'Armstrong Siddeley Jaguar IV (S)',
                            'BMW VI',
                            'Auguste Rateau',
                            'Bristol Mercury',
                            'P&Whitney R-4360',
                            'Sanford Alexander Moss',
                            'Jendrassik Cs-1',
                            'Gen Electric GE36',
                            'Bell X-1',
                            'P&Whitney R-4360',
                        ],
                    ],
                },
                meta: { totalCount: 20 },
            },
        }}
    />
);
